/**
 * @flow
 */

import { Map } from 'immutable';
import { subMonths, startOfYear } from 'date-fns';

const toDate = subMonths(new Date(), 2);

const initialState = Map({
    searchQuery: '',
    settings: {},
    showArchive: false,
    fromDate: startOfYear(toDate),
    toDate,
});

export default (state: Map<string, any> = initialState, action: Object) => {
    switch (action.type) {
        case 'SALON.SEARCH': {
            return state.set('searchQuery', action.query);
        }
        case 'SALON.SETTINGS': {
            return state.set('settings', action.settings);
        }
        case 'SALON.SHOW_ARCHIVE': {
            return state.set('showArchive', action.showArchive);
        }
        case 'SALON.SET_DATE': {
            return state
                .set('fromDate', action.fromDate)
                .set('toDate', action.toDate);
        }
        default: {
            return state;
        }
    }
};
